import { makeAutoObservable } from "mobx";
export interface Location {
  id: string;
  name: string;
  isActive: boolean;
}

export class LocationModel implements Location {
  readonly id: string;
  name: string;
  isActive: boolean = true;

  constructor(location: Location) {
    makeAutoObservable(this);
    this.id = location.id;
    this.name = location.name;
    this.isActive = location.isActive ?? true;
  }
  get canSave() {
    return Boolean(this.name.trim());
  }
  setName(name: string) {
    this.name = name;
  }
}